import { Field, Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { PTInputText } from '../../components/PTElements';
import { SubmitButton } from '../../components/SubmitButton';
import { EVO } from '../../EVO';

export const ClientSmsCredit = props => {
    const client = useSelector(({ clients }) => clients.client);
    const [credit, setCredit] = useState(0);

    useEffect(() => {
        setCredit(client.smsCredit);
    }, [client.smsCredit]);

    const handleSubmit = (values, { setSubmitting }) => {
        EVO.post('/api/clients/adjustSmsCredit', { id: client.id, smsAdjustment: values.smsAdjustment }).then(r => {
            let message = `Successfully adjusted by ${values.smsAdjustment} credits.`;
            if (r.smsCredit) {
                message += ` New credit for Client is ${r.smsCredit}`;
                setCredit(r.smsCredit);
            }
            EVO.success(message);
            setSubmitting(false);
        }).catch(e => {
            setSubmitting(false);
            EVO.error('Error updating SMS Credit');
        });
    };

    const NameForm = ({ errors, touched, handleSubmit, isSubmitting }) => (
        <Form>
            <div>Current Credit: {credit}</div>
            <label>
                <Field name="smsAdjustment" component={PTInputText} left="true" type="number" placeholder="Credit Adjustment"></Field>
                <SubmitButton type="submit" disabled={isSubmitting} classNames={{ 'loading': isSubmitting }} text="Adjust" />
            </label>
        </Form>
    );

    return <div>
        <h3>SMS Credit Adjustments</h3>
        <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            children={NameForm}
        />
        {client.smsCreditLogs &&
            <table className="sms-credit-log">
                <thead>
                    <th>Date</th>
                    <th>Credits</th>
                    <th>Reason</th>
                </thead>
                <tbody>
                    {client.smsCreditLogs.map(l => 
                        <tr key={l.dateAdded}>
                            <td>{EVO.format(l.dateAdded, 'dd/MM/yyyy HH:mm')}</td>
                            <td>{l.smsCredits}</td>
                            <td>{l.reason}</td>
                        </tr>)}
                </tbody>
            </table>
        }
        </div>
};

const initialValues = {
    smsAdjustment: 25
};






// WEBPACK FOOTER //
// ./src/pages/Clients/ClientSmsCredit.js